import { Link } from 'react-router-dom'

import { manifests } from '@senses/games'

import { Spinner } from '../components/ui.tsx'
import { api } from '../lib/api.ts'
import { useAsync } from '../lib/hooks.ts'

const CATEGORY_LABELS: Record<string, string> = {
  tracking: 'Sledování objektů',
  reaction: 'Reakce',
  peripheral: 'Periferní vidění',
  memory: 'Pracovní paměť',
  saccades: 'Oční pohyby',
  other: 'Ostatní',
}

/** Katalog nainstalovaných her. Trenér si odsud může nastavení rovnou vyzkoušet. */
export function GameCatalogPage(): React.JSX.Element {
  const programs = useAsync(() => api.programs.list(), [])

  return (
    <main className="page">
      <div className="page__header">
        <div>
          <h1>Katalog her</h1>
          <p>
            Hry nainstalované v této verzi aplikace. Vyzkoušej si nastavení dřív, než ho přiřadíš
            klientovi.
          </p>
        </div>
      </div>

      {programs.loading && <Spinner />}

      <div className="grid grid--wide">
        {manifests.map((manifest) => {
          const related = (programs.data?.programs ?? []).filter((p) => p.gameId === manifest.id)

          return (
            <div className="card" key={manifest.id}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                <span style={{ fontSize: '2rem', lineHeight: 1 }}>{manifest.icon}</span>
                <div style={{ flex: 1 }}>
                  <h3>{manifest.name}</h3>
                  <p className="dim" style={{ fontSize: '0.8rem' }}>
                    {CATEGORY_LABELS[manifest.category] ?? manifest.category} · v{manifest.version}
                  </p>
                </div>
              </div>

              <p className="muted" style={{ fontSize: '0.9rem', marginTop: '0.85rem' }}>
                {manifest.description}
              </p>

              <p className="field__help" style={{ marginTop: '0.85rem' }}>
                Sleduje se: <strong>{manifest.primaryMetric.label}</strong>
                {manifest.primaryMetric.higherIsBetter ? ' (vyšší je lepší)' : ' (nižší je lepší)'}
              </p>

              {related.length > 0 && (
                <div style={{ marginTop: '1rem' }}>
                  <div className="stat__label" style={{ marginBottom: '0.5rem' }}>
                    Hotové programy
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
                    {related.map((program) => (
                      <Link
                        key={program.id}
                        to={`/hra/program/${program.id}`}
                        className="btn btn--sm"
                        title="Spustit zkušební sérii"
                      >
                        ▶ {program.name}
                      </Link>
                    ))}
                  </div>
                </div>
              )}

              <div style={{ marginTop: '1.25rem' }}>
                <Link to={`/programy/novy?game=${manifest.id}`} className="btn btn--primary btn--sm">
                  Vytvořit program
                </Link>
              </div>
            </div>
          )
        })}
      </div>

      <p className="field__help" style={{ marginTop: '2rem' }}>
        Novou hru přidáš založením adresáře v <code>packages/games/src/</code>. Objeví se tady
        automaticky po spuštění <code>npm run games:sync</code>.
      </p>
    </main>
  )
}
